import ModalContainer from '../components/ModalContainer';
import ConfirmIrreversible from '../components/ConfirmIrreversible';
import styles from '../SCSS/DeleteClassroomModal.module.scss';

interface Props {
  classroomName: string;
  numOfStudents: string;
  show: boolean;
  hideModal: () => void;
  confirmTestString: string;
  deleteClassroom: () => void;
}

const DeleteClassroomnModal = (props: Props): JSX.Element => {
  const warningMessage = (
    <span className={styles.warningMessage}>
      Are you sure you want to delete your classroom{' '}
      <strong className={styles.bold}>&ldquo;{props.classroomName || 'Main Class'}&rdquo;</strong> with{' '}
      <strong className={styles.bold}>{props.numOfStudents || 0}</strong> students? This will delete the classroom and
      related data, including all student work associated with this class.{' '}
      <strong className={styles.bold}>This is permanent and cannot be undone.</strong>
    </span>
  );
  const instructions = 'To confirm, please type out the name of your classroom below.';

  return (
    <>
      {props.show && (
        <ModalContainer hideModal={props.hideModal}>
          <ConfirmIrreversible
            hideModal={props.hideModal}
            title='Delete Classroom'
            confirmTestString={props.confirmTestString}
            performIrreversibleAction={props.deleteClassroom}
            instructions={instructions}
            warningMessage={warningMessage}
          />
        </ModalContainer>
      )}
    </>
  );
};

export default DeleteClassroomnModal;
